export default __webpack_public_path__ + "locales/nl/Article.json?hash=dfb28f27935c6867095a1521b1e2faab";